var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHugBrush4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 183,
    viewBox: "0 0 298 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10 44.25C17.25 72.5 43.5 52 48.25 46.5C56.3503 37.1207 83.2482 -2.77966 105.25 16.75C125.264 34.5155 108.668 57.7428 96.25 72C83.8324 86.2572 37.763 125.347 57.25 141.25C76.737 157.153 120.75 132.5 146.25 95.5C171.75 58.5 181.816 25.7176 202.25 30.5C214 33.25 202.25 77.5 226.5 77.5C252.75 77.5 243.5 47.75 274 47.75C283.5 47.75 291.25 51.85 291.25 59.25C291.25 98.25 178.25 89 178.25 152C178.25 172 209 184 237.75 152C261.582 125.474 283.5 117.5 308.25 128.25",
    stroke: "#000",
    strokeWidth: 21,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugBrush4);
export default __webpack_public_path__ + "static/media/hug-brush-4.8384aea401d4cd336c72b49289465f88.svg";
export { ForwardRef as ReactComponent };